import http from '../request/http'
export function formatDate(time) {
  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let miute = date.getMinutes();
  return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hour > 9 ? hour : '0' + hour}:${miute > 9 ? miute : '0' + miute}`;
}
//存入sessionStorage
export const SaveToSessionStorage = (key, value) => {
  value = escape(JSON.stringify(value));
  sessionStorage.setItem(key, value);
};
//从sessionStorage中取,type: 1-string, 2-json, default-json
export const GetFromSessionStorage = (key, type) => {
  type = typeof type == 'undefined' ? 2 : type;
  var value = sessionStorage.getItem(key);
  value = unescape(value);

  if (typeof value == 'undefined' || value == 'undefined') {
    return;
  }
  if (type == 1) {
    return value;
  } else {
    return JSON.parse(value);
  }
}
//存入sessionStorage
export const SaveToLocalStorage = (key, value) => {
  value = escape(JSON.stringify(value));
  localStorage.setItem(key, value);
};
//从sessionStorage中取,type: 1-string, 2-json, default-json
export const GetFromLocalStorage = (key, type) => {
  type = typeof type == 'undefined' ? 2 : type;
  var value = localStorage.getItem(key);
  value = unescape(value);

  if (typeof value == 'undefined' || value == 'undefined') {
    return;
  }
  if (type == 1) {
    return value;
  } else {
    return JSON.parse(value);
  }
}
export const getCustomerPhone = (self, done) => {
  http.post('/api/wap/public/mobile',).then(res => {
    if (res.errno == 0) {
      self.$cookies.set('customer_phone', res.data.mobile);
      done(res.data.mobile)
    } else {
      done('')
    }
  }).catch(err => {
    done('')
  })
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}
export function isIphoneX() {
  if (/iPhone/gi.test(window.navigator.userAgent)) {
    if (window.screen.height >= 812) {
      return true;
    } else {
      return false;
    }
  } else {
    return false
  }
}




// WEBPACK FOOTER //
// ./src/utils/index.js